export default __webpack_public_path__ + "static/media/small_maddy.77c66c5d.png";